"use client";

import OfferRow from "./offerRow";
import { Offer } from "@prisma/client";
import { FetchedOffer } from "./actions";

const Offers = ({ offers }: { offers: Array<FetchedOffer> }) => {
  return (
    <div className="">
      {offers.map((offer) => {
        return <OfferRow fetchedOffer={offer} key={offer.id} />;
      })}
    </div>
  );
};

export default Offers;
